var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4C8A5C",
    strokeWidth: 2,
    d: "M30.74 10a32.4 32.4 0 0 0-4.08-4.243C23.206 2.774 19.583 1 16 1S8.794 2.774 5.34 5.757A32.4 32.4 0 0 0 1.26 10a32.4 32.4 0 0 0 4.08 4.243C8.794 17.226 12.417 19 16 19s7.206-1.774 10.66-4.757A32.4 32.4 0 0 0 30.74 10zM16 15a5 5 0 1 1 0-10 5 5 0 0 1 0 10z"
  })));
});
const SvgEyeDocPreviewIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEyeDocPreviewIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDMyIDIwIj4KICAgIDxwYXRoIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjNEM4QTVDIiBzdHJva2Utd2lkdGg9IjIiIGQ9Ik0zMC43NCAxMGEzMi40MSAzMi40MSAwIDAgMC00LjA4LTQuMjQzQzIzLjIwNiAyLjc3NCAxOS41ODMgMSAxNiAxUzguNzk0IDIuNzc0IDUuMzQgNS43NTdBMzIuNDEgMzIuNDEgMCAwIDAgMS4yNiAxMGEzMi40MSAzMi40MSAwIDAgMCA0LjA4IDQuMjQzQzguNzk0IDE3LjIyNiAxMi40MTcgMTkgMTYgMTlzNy4yMDYtMS43NzQgMTAuNjYtNC43NTdBMzIuNDEgMzIuNDEgMCAwIDAgMzAuNzQgMTB6TTE2IDE1YTUgNSAwIDEgMSAwLTEwIDUgNSAwIDAgMSAwIDEweiIvPgo8L3N2Zz4K";